import { Card, Collapse } from "@mui/material";
import CardBody from "../../../../../components/Card/CardBody";
import FormTextTC from "../../../../../components/Forms/FormTextTC";
import React from "react";
import { ArrangementVariant } from "../General";

export function SupplementaryArrangement({ variant }: { variant: ArrangementVariant }) {
  return (
    <Collapse in={variant === "supplementary"}>
      <Card>
        <CardBody>
          A supplementary arrangement has no rules. It acts as one additional cover to whatever regular arrangement is
          on the table.
          <FormTextTC
            name={"name"}
            rules={{
              required: true,
            }}
            tDefault={"Name"}
            tKey={"arrangements.name"}
          />
        </CardBody>
      </Card>
    </Collapse>
  );
}
